export enum AuthenticationState {
  NotAuthenticated = 0,
  RenewPasswordRequired = 1,
  NoTenantSelected = 2,
  Administration = 3,
  Authenticated = 4,
  ApplicationAccessDenied = 5
}
